// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"PurchaseTimeframeStep_cardContainer__3xyZ9"};